
// --- Vue & Template imports ---
import { Component, Prop, Vue } from 'vue-property-decorator';

// --- Models ---
import { Customer, AccommodationCustomer, RestaurantCustomer, SupplierCustomer } from '@/models/Customer.model';

// --- Services ---
import AppService from '@/services/app';
import CustomerService from '@/services/customer';

// --- Third Party ---

@Component
export default class CompleteRegistrationPage extends Vue {

  clickedItem: Customer = {
    industryId: 0,
    customerStatusId: 0,
    companyName: '',
    branch: '',
    tradingName: '',
    regNumber: '',
    vatNumber: '',
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    city: '',
    province: '',
    country: 'South Africa',
    postalCode: '',
    publicPhoneNumber: '',
    publicEmail: '',
    publicWhatsapp: '',
    website: '',
    logoFilename: '',
    mainContactName: '',
    mainContactPosition: '',
    mainContactPhone: '',
    mainContactEmail: '',
  };

  accommodationItem: AccommodationCustomer = {
    rooms: 0,
    seasonalClosure: '',
  }

  restaurantItem: RestaurantCustomer = {
    covers: 0,
    operatingHours: '',
    seasonalClosure: '',
  }

  supplierItem: SupplierCustomer = {
    distributionTypeId: 0,
  }

  uploadFiles: File[] = [];
  logoUrl: string = '';
  selectedIndustrySectorIds: number[] = [];

  tandc: boolean = false;
  valid: boolean = false;
  clicked: boolean = false;

  rules = {
    required: (value: string | number) => !!value || '',
    optionalFilesize1Mb: (value: File) => value ? (!value || value.size < 1048576 || 'File size should be less than 1 MB') : true,
    optionalImageFileType: (value: File) => value ? (value.type === 'image/jpeg' || value.type === 'image/png' || 'Invalid file type. Must be an image') : true,
    // companyRegistrationNumber: (value: string) => /^[0-9]{4}\/[0-9]{6}\/[0-9]{2}$/.test(value) || 'Invalid South African Company Registration Number',
    vatNumber: (value: string) => value ? /^[4][0-9]{9}$/.test(value) || 'Invalid South African VAT Number' : true,
    numbersOnly: (value: string) => value ? (/^\d+$/.test(value)) || 'Invalid character' : true,
    postalCode: (value: number) => value < 10000 || 'Invalid Postal Code',
    url: (value: string) => value ? /^(http(s?):\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&\/\/=]*)$/.test(value) || 'Website URL must be valid' : true,
    name: (value: string) => value ? /^[A-Za-z -]+$/.test(value.trim()) || 'Name must only contain letters' : true,
    email: (value: string) => value ? /(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(value) || 'E-mail must be valid' : true,
    mustHaveOneIndustrySector: (value: boolean) => this.mustHaveOneIndustrySector(),
  };

  // #region Functions to assist with validation
    mustHaveOneIndustrySector() {
      return this.selectedIndustrySectorIds.length > 0;
    }
  // #endregion


  // #region Functions to display list data on page load
    async beforeMount() {
      await CustomerService.listAllIndustrySectors(false);
    }

    showLogoPreview() {
      if (this.uploadFiles && this.uploadFiles[0]) {
        this.logoUrl = URL.createObjectURL(this.uploadFiles[0]);
      } else {
        this.logoUrl = '';
        if (this.uploadFiles[0]) {
          delete this.uploadFiles[0];
        }
      }
    }

    getAccommodationNumberType() {
      if (!Array.isArray(this.selectedIndustrySectorIds) && this.selectedIndustrySectorIds) {
        let industryType = this.$store.getters['customers/getIndustrySectorById'](this.selectedIndustrySectorIds).type;
        if (industryType === 'Self Catering') {
          return 'Number of units*';
        } else if (industryType === 'Backpackers & Hostels') {
          return 'Sleeping capacity*';
        } else if (industryType === 'Caravan & Camping') {
          return 'Number of campsites*';
        }
      }
      return 'Number of rooms*';
    }

    async completeRegistration() {
      try {
        this.clicked = true;

        const formData = new FormData();

        formData.append('tradingName', '' + this.clickedItem.tradingName);
        formData.append('regNumber', '' + this.clickedItem.regNumber);
        formData.append('vatNumber', '' + this.clickedItem.vatNumber);
        formData.append('addressLine1', '' + this.clickedItem.addressLine1);
        formData.append('addressLine2', '' + this.clickedItem.addressLine2);
        formData.append('addressLine3', '' + this.clickedItem.addressLine3);
        formData.append('city', '' + this.clickedItem.city);
        formData.append('province', '' + this.clickedItem.province);
        formData.append('country', '' + this.clickedItem.country);
        formData.append('postalCode', '' + this.clickedItem.postalCode);
        formData.append('publicPhoneNumber', '' + this.clickedItem.publicPhoneNumber);
        formData.append('publicEmail', '' + this.clickedItem.publicEmail);
        formData.append('publicWhatsapp', '' + this.clickedItem.publicWhatsapp);
        formData.append('website', '' + this.clickedItem.website);
        formData.append('mainContactName', '' + this.clickedItem.mainContactName);
        formData.append('mainContactPosition', '' + this.clickedItem.mainContactPosition);
        formData.append('mainContactPhone', '' + this.clickedItem.mainContactPhone);
        formData.append('mainContactEmail', '' + this.clickedItem.mainContactEmail);        

        formData.append('industrySectorIds', '' + (!Array.isArray(this.selectedIndustrySectorIds) ? this.selectedIndustrySectorIds : this.selectedIndustrySectorIds.join(',')));

        formData.append('rooms', '' + this.accommodationItem.rooms);
        formData.append('covers', '' + this.restaurantItem.covers);
        formData.append('operatingHours', '' + this.restaurantItem.operatingHours);
        formData.append('distributionTypeId', '' + this.supplierItem.distributionTypeId);

        if (this.$store.getters['users/loggedInUser'].industryId === 1) {
          formData.append('seasonalClosure', '' + this.accommodationItem.seasonalClosure);
        } else {
          formData.append('seasonalClosure', '' + this.restaurantItem.seasonalClosure);
        }

        formData.append('logoFile', this.uploadFiles[0]);

        const response = await CustomerService.completeRegistration( formData );

        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            if (response.data.message === 'Reload Customer Status') {
              // when we tried to register this customer, they already had a further along customer status, so re-fetch the auth data and figure out which page they need to be on to continue their journey
              Vue.$cookies.remove('_t'); // removing the cookie so that the auth re-fetches the updated status id's from the DB
              this.$router.push('/');
            } else {
              AppService.errorHandler(response.data.message);
            }
          } else {
            AppService.successHandler('Customer Details Saved');
            Vue.$cookies.remove('_t'); // removing the cookie so that the auth re-fetches the updated status id's from the DB
            this.$router.push('/package-selection'); // go to the next step of registration
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {

        if (error.response) {
          AppService.errorHandler(error.response.statusText);
        } else {
          AppService.logSupportDebug('CompleteRegistration.vue - completeRegistration - 685 - ' + error);
          AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
        }

      } finally {
        this.clicked = false;
      }
    }
  // #endregion

}
